export class TabulationTotalsOptions {
  constructor(
    public showRowSubtotals: boolean = false,
    public showRowTotals: boolean = false,
    public showColumnSubtotals: boolean = false,
    public showColumnTotals: boolean = false
  ) {}
}
